import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-bank-acount-setup',
  templateUrl: './customer-bank-acount-setup.component.html',
  styleUrls: ['./customer-bank-acount-setup.component.css']
})
export class CustomerBankAcountSetupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
